/** A lost account (ADR-0039): the full-screen breach notice with the numbers and the way back, and the history on the
 *  accounts page. */
export default {
  eyebrow: "Account stopped",
  title: "The account is stopped — the limit is lost",
  lead: "A program rule was broken, so trading on this account is over. Open orders were cancelled and every position was closed at the market.",
  rules: {
    max_loss: "Maximum loss: equity fell to the account's floor",
    daily_loss: "Daily loss: equity fell below today's limit",
    max_trade_loss: "Loss per trade: one trade lost more than allowed",
    consistency: "Consistency: one day made too large a share of the profit",
    max_duration: "Time is up: the phase ran past its last day",
    inactivity: "Inactivity: no trades for too long",
    max_trading_days: "Trading days used up before the target",
  },
  limit: "Limit",
  observed: "At the breach",
  days: { one: "{count} day", other: "{count} days" },
  at: "When",
  result: "Final result",
  balance: "Balance {balance} of {start}",
  closedTitle: "All positions were closed",
  closedNone: "There were no open positions.",
  closing: "Closing the positions…",
  long: "Long",
  short: "Short",
  next: "What next",
  reset: {
    title: "Reset for {price}",
    note: "{pct} % of the {base} the account cost. The same account from the start: same rules, same size.",
    noteFixed: "The same account from the start: same rules, same size.",
    confirm: "Pay {price} and restart",
  },
  coupon: {
    title: "New account with −{pct} %",
    note: "Your personal coupon for the next purchase. Valid until {date}, once.",
    copy: "Copy",
    copied: "Copied",
    go: "Choose an account",
    used: "This coupon has already been used.",
  },
  free: {
    title: "Use the free reset",
    note: "It came with your purchase. Activation: {fee}.",
    noteFree: "It came with your purchase.",
    confirm: "Pay {fee} and restart",
    confirmFree: "Restart for free",
  },
  back: "Back",
  close: "Close",
  history: "Go to history",
  more: { one: "{count} more account was stopped — it is in the history.", other: "{count} more accounts were stopped — they are in the history." },
  reasons: {
    already_restarted: "This account has already been restarted.",
    not_failed: "Only a stopped account can be restarted.",
    reset_fee_due: "Paying for a reset is not available yet. Write to support.",
    bonus_activation_due: "Paying the activation is not available yet. Write to support.",
    no_reset_fee: "This program has no paid reset.",
  },
  log: {
    title: "History",
    lead: "Stopped, passed and closed accounts, and how each one ended.",
    rule: "Rule: {rule}",
    result: "Result",
    details: "Details",
    open: "Open",
  },
};
